var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "awb-verification"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [(!_vm.isverificationenabled) ? _c('fieldset', [_c('b-card', [_c('h4', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.isverificationenabledMsg))])])])], 1) : _vm._e(), _vm._v(" "), (_vm.isverificationenabled) ? _c('fieldset', [_c('legend', [_vm._v("AWB verification(Dim & Wt)")]), _vm._v(" "), _c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingSearch
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingSearch = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("AWB")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.AWBnumber),
      expression: "AWBnumber"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('dimension.AWB')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter AWB",
      "name": "AWB",
      "id": "AWB",
      "data-vv-scope": "dimension"
    },
    domProps: {
      "value": (_vm.AWBnumber)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getAWBList.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.AWBnumber = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('dimension.AWB')),
      expression: "errors.has('dimension.AWB')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('dimension.AWB')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticStyle: {
      "cursor": "pointer",
      "font-size": "16px"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    staticStyle: {
      "margin-top": "37px"
    },
    attrs: {
      "title": "Reload AWB"
    },
    on: {
      "click": _vm.resetAWBData
    }
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "15px"
    }
  }, [_vm._v("AWB Measurement Status:  "), _c('b', [_vm._v(_vm._s(_vm.AWBStatus))])])])], 1), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmitDimension('dimension')
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("MPS")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.MPSnumber),
      expression: "MPSnumber"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "mps",
    class: {
      'form-control': true, 'error': _vm.errors.has('dimension.MPS')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter MPS",
      "name": "MPS",
      "id": "MPS",
      "data-vv-scope": "dimension"
    },
    domProps: {
      "value": (_vm.MPSnumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.MPSnumber = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('dimension.MPS')),
      expression: "errors.has('dimension.MPS')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('dimension.MPS')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "margin-left": "32px"
    }
  }, [_c('label', [_vm._v("Measurement Method")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), (!_vm.measurementmethod && _vm.type) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Select Measurement Method")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.measurementmethod),
      expression: "measurementmethod"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "Manual",
      "data-vv-scope": "dimension",
      "id": "Manual",
      "value": "Manual"
    },
    domProps: {
      "checked": _vm._q(_vm.measurementmethod, "Manual")
    },
    on: {
      "change": function($event) {
        _vm.measurementmethod = "Manual"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-circle",
    staticStyle: {
      "cursor": "pointer"
    }
  })])]), _c('label', {
    attrs: {
      "for": "Manual"
    }
  }, [_vm._v("Manual")])])])]), _vm._v(" "), _c('legend', [_vm._v("Measurements")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Dimension UOM")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), (!_vm.dimensionUOM && _vm.type) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Select Dimesions")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 radio"
  }, [_c('b-form-fieldset', [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dimensionUOM),
      expression: "dimensionUOM"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "Centimeter",
      "id": "Centimeter",
      "value": "Centimeter",
      "data-vv-scope": "dimension"
    },
    domProps: {
      "checked": _vm._q(_vm.dimensionUOM, "Centimeter")
    },
    on: {
      "change": function($event) {
        _vm.dimensionUOM = "Centimeter"
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-circle",
    staticStyle: {
      "cursor": "pointer"
    }
  })])]), _c('label', {
    attrs: {
      "for": "Centimeter"
    }
  }, [_vm._v("Centimeter")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Length")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-arrows-v'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.length),
      expression: "length"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('dimension.Length')
    },
    attrs: {
      "type": "text",
      "tabindex": "-1",
      "placeholder": "Enter Length",
      "name": "Length",
      "id": "Length",
      "data-vv-scope": "dimension"
    },
    domProps: {
      "value": (_vm.length)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.length = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('dimension.Length')),
      expression: "errors.has('dimension.Length')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('dimension.Length')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Breadth")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-arrows'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.breadth),
      expression: "breadth"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('dimension.Breadth')
    },
    attrs: {
      "type": "text",
      "tabindex": "-1",
      "placeholder": "Enter Breadth",
      "name": "Breadth",
      "id": "Breadth",
      "data-vv-scope": "dimension"
    },
    domProps: {
      "value": (_vm.breadth)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.breadth = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('dimension.Breadth')),
      expression: "errors.has('dimension.Breadth')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('dimension.Breadth')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Height")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-arrows-v'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.height),
      expression: "height"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('dimension.Height')
    },
    attrs: {
      "type": "text",
      "tabindex": "-1",
      "placeholder": "Enter Height",
      "name": "Height",
      "id": "Height",
      "data-vv-scope": "dimension"
    },
    domProps: {
      "value": (_vm.height)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.height = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('dimension.Height')),
      expression: "errors.has('dimension.Height')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('dimension.Height')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Weight(kg)")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-balance-scale'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.weight),
      expression: "weight"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('dimension.Weight')
    },
    attrs: {
      "type": "text",
      "tabindex": "-1",
      "placeholder": "Enter Weight",
      "name": "Weight",
      "id": "Weight",
      "data-vv-scope": "dimension"
    },
    domProps: {
      "value": (_vm.weight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.weight = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('dimension.Weight')),
      expression: "errors.has('dimension.Weight')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('dimension.Weight')))])], 1)]), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("Reset")])])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isverificationenabled) ? _c('fieldset', [_c('legend', [_vm._v("List")]), _vm._v(" "), _c('b-card', [_c('div', [_c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: "fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  }, [_vm._v(" Filter")])]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Search by MPS / Checkbox")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-industry'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.FltMPSnumber),
      expression: "FltMPSnumber"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter MPS",
      "name": "MPS",
      "id": "MPS",
      "disabled": _vm.disableMPSField
    },
    domProps: {
      "value": (_vm.FltMPSnumber)
    },
    on: {
      "keyup": _vm.validateMPSField,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.FltMPSnumber = $event.target.value
      }
    }
  })]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errorMessage))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 checkbox",
    staticStyle: {
      "margin-top": "35px"
    }
  }, [_c('b-form-fieldset', [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.FltIsMeasurement),
      expression: "FltIsMeasurement"
    }],
    attrs: {
      "type": "checkbox",
      "id": "MeasurementNotDone",
      "value": "MeasurementNotDone",
      "disabled": _vm.disableField
    },
    domProps: {
      "checked": Array.isArray(_vm.FltIsMeasurement) ? _vm._i(_vm.FltIsMeasurement, "MeasurementNotDone") > -1 : (_vm.FltIsMeasurement)
    },
    on: {
      "click": _vm.validateCheckField,
      "change": function($event) {
        var $$a = _vm.FltIsMeasurement,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "MeasurementNotDone",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.FltIsMeasurement = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.FltIsMeasurement = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.FltIsMeasurement = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check",
    staticStyle: {
      "cursor": "pointer"
    }
  })])]), _c('label', {
    attrs: {
      "for": "MeasurementNotDone"
    }
  }, [_vm._v("Measurement Not Done")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.getAWBData
    }
  }, [_vm._v("Search")]), _vm._v(" \n                      "), _c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetFlt
    }
  }, [_vm._v("Reset")])])])])])], 1), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "height": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-3 cardlistheader"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Scanned MPS Measurement")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 cardlistheader"
  }, [_c('b', [_vm._v("AWB:" + _vm._s(_vm.AWB))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 cardlistheader"
  }, [_c('b', [_vm._v("TotalMPS:" + _vm._s(_vm.ScannedMPSList.length))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 cardlistheader"
  }, [_c('b', [_vm._v("MPS Measured:" + _vm._s(_vm.MPSMeasuredCount))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.ScannedMPSList.length < 1
    },
    on: {
      "click": function($event) {
        return _vm.getCSVFile()
      }
    }
  }, [_vm._v("Download .XLSX")])])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingSearch
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingSearch = $event
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto",
      "height": "300px"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('col'), _vm._v(" "), _c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("MPS ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("Physical"), _c('br'), _c('span', [_vm._v(" Weight(kg)")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Dimensions")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("Dimension UOM")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("CFT")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("Volumetric"), _c('br'), _c('span', [_vm._v(" Weight(kg)")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("Measurement"), _c('br'), _c('span', [_vm._v(" Method")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("Measurement "), _c('br'), _c('span', [_vm._v(" Date&Time")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("Measurement "), _c('br'), _c('span', [_vm._v(" Location")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("Measurement "), _c('br'), _c('span', [_vm._v(" Done By")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "rowspan": "3"
    }
  }, [_vm._v("Action")])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Length")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Width")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Height")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.ScannedMPSList), function(data, index) {
    return (_vm.showAll) ? _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.MPSID))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("toFixedNum")(data.PhysicalWeight)))]), _vm._v(" "), _c('td', {
      attrs: {
        "scope": "col"
      }
    }, [_vm._v(_vm._s(_vm._f("toFixedNum")(data.Dimensions.Length)))]), _vm._v(" "), _c('td', {
      attrs: {
        "scope": "col"
      }
    }, [_vm._v(_vm._s(_vm._f("toFixedNum")(data.Dimensions.Width)))]), _vm._v(" "), _c('td', {
      attrs: {
        "scope": "col"
      }
    }, [_vm._v(_vm._s(_vm._f("toFixedNum")(data.Dimensions.Height)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.Dimensions.Unit))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.CFT))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("toFixedNum")(data.VolumetricWeight)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.MeasurementMethod))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.MeasurementDateandTime)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.MeasurementLocation))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.MeasurementDoneBy))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "btn btn-link",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.getRowData(data)
        }
      }
    }, [_vm._v("Re-Measure")])])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.ScannedMPSListFLT), function(data, index) {
    return (_vm.ScannedMPSListFLT.length > 0) ? _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.MPSID))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("toFixedNum")(data.PhysicalWeight)))]), _vm._v(" "), _c('td', {
      attrs: {
        "scope": "col"
      }
    }, [_vm._v(_vm._s(_vm._f("toFixedNum")(data.Dimensions.Length)))]), _vm._v(" "), _c('td', {
      attrs: {
        "scope": "col"
      }
    }, [_vm._v(_vm._s(_vm._f("toFixedNum")(data.Dimensions.Width)))]), _vm._v(" "), _c('td', {
      attrs: {
        "scope": "col"
      }
    }, [_vm._v(_vm._s(_vm._f("toFixedNum")(data.Dimensions.Height)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.Dimensions.Unit))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.CFT))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("toFixedNum")(data.VolumetricWeight)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.MeasurementMethod))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.MeasurementDateandTime)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.MeasurementLocation))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.MeasurementDoneBy))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "btn btn-link",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.getRowData(data)
        }
      }
    }, [_vm._v("Re-Measure")])])]) : _vm._e()
  }), _vm._v(" "), (_vm.noRecord) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "16"
    }
  }, [_vm._v("No Record found")])]) : _vm._e()], 2)])])], 1)], 1)])], 1) : _vm._e()])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d8680ac","hasScoped":true}!./src/views/components/AWBVerification/AWBVerification.html
// module id = 1281
// module chunks = 2